<template>
  <div class="reset-password-error">
    <div class="reset-password-error__top-bar">
      <Beacon class="reset-password-error__beacon" />
    </div>
    <div class="reset-password-error__container">
      <div class="reset-password-error__content">
        <TenderLogo class="reset-password-error__tender-logo" width="145" />

        <h1 class="reset-password-error__title">{{ $t('forgot-password.expired-page.title') }}</h1>
        <p class="reset-password-error__text">
          <strong>{{ $t('forgot-password.expired-page.subtitle1') }}</strong>
        </p>
        <p class="reset-password-error__text">{{ $t('forgot-password.expired-page.subtitle2') }}</p>

        <div class="reset-password-error__buttons">
          <BaseButton :to="newRequest" class="reset-password-error__button" has-icon-right>
            {{ $t('forgot-password.expired-page.btn') }}
            <BaseIcon name="arrow-right" />
          </BaseButton>
          <BaseButton to="/login" class="reset-password-error__button" is-outlined>
            {{ $t('forgot-password.back-to-login') }}
          </BaseButton>
        </div>
      </div>
      <DeadLink class="reset-password-error__image" height="403" />
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon';
import Beacon from '@/components/Beacon';
import DeadLink from '@/assets/images/dead-link.svg';
import TenderLogo from '@/assets/images/aloha-logo.svg';

export default {
  name: 'PageResetPasswordError',
  components: {
    BaseButton,
    BaseIcon,
    Beacon,
    DeadLink,
    TenderLogo,
  },
  computed: {
    newRequest() {
      return {
        name: 'forgot-password',
      };
    },
  },
};
</script>

<style lang="scss">
.reset-password-error {
  align-items: center;
  background-color: $color-white;
  display: flex;
  flex-direction: column;
  min-height: var(--viewport-height);
  padding: 32px;
  width: 100%;

  &__top-bar {
    display: flex;
    max-width: 450px;
    width: 100%;
  }

  &__beacon {
    margin-left: auto;
  }

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    max-width: 450px;
    width: 100%;
  }

  &__tender-logo {
    color: $color-brand-500;
    margin-bottom: 40px;
  }

  &__title {
    margin: 0 0 24px;
  }

  &__text {
    font-size: $font-size-small;
    margin-bottom: 16px;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
  }

  &__button {
    margin-top: 24px;
  }

  &__image {
    height: auto;
    margin-top: 40px;
    width: 200px;
  }
}

@media screen and (min-width: 784px) {
  .reset-password-error {
    &__top-bar {
      max-width: initial;
    }

    &__container {
      flex-direction: row;
      max-width: 784px;
    }

    &__content {
      margin-right: 32px;
    }

    &__buttons {
      align-items: center;
      display: flex;
      flex-direction: row;
      margin-top: 40px;
    }

    &__button {
      margin-right: 32px;
      margin-top: 0;
    }

    &__image {
      margin-left: auto;
      margin-top: 0;
      width: auto;
    }
  }
}
</style>
